import { ActionTypes } from './types';

export const setEditedConditionId = (id: string | null) => ({
  type: ActionTypes.SET_EDITED_CONDITION_ID,
  payload: id
});
